module.exports = __webpack_public_path__ + "img/daniel.46516f9c.jpg";